import { IconButton, TableBody, TableCell, TableRow, List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { BaseTable } from "../../../components/table";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { GroupsTablePropsType } from "../../../types/container.type";

export const GroupsTable: React.FC<GroupsTablePropsType> = ({ rows, dropdownRef, selectedGroupId, handleEllipsisButtonClick, handleActionItemClick }) => {
    const actions = ["Edit Group"];
    const groupsTableHeaders = ["Name", "Branch", "Account Number", "Status", "Action"];
    return (
        <BaseTable
            headers={groupsTableHeaders}
        >
            <TableBody>
                {rows?.map((row, index) => (
                    <TableRow key={index}>
                        <TableCell>
                            {`${row?.name?.charAt(0).toUpperCase()}` + row?.name?.slice(1)}
                        </TableCell>
                        <TableCell>{row?.branch}</TableCell>
                        <TableCell>{row?.accountNumber}</TableCell>
                        <TableCell>{row?.status?.charAt(0).toUpperCase() + row?.status?.slice(1) || "NA"}</TableCell>
                        <TableCell>
                            <IconButton
                                sx={{
                                    borderRadius: "0.5rem",
                                    backgroundColor: "var(--sky-blue-color)",
                                    "&:hover": {
                                        backgroundColor: "var(--sky-blue-color)"
                                    }
                                }}
                                onClick={(e) => handleEllipsisButtonClick(e, row?.id)}
                            >
                                <MoreVertIcon
                                    sx={{
                                        color: "#FFFFFF",
                                        display: "inline-flex",
                                    }}
                                />
                            </IconButton>
                            {(selectedGroupId && selectedGroupId === row?.id) && (
                                <List
                                    component={"ul"}
                                    ref={dropdownRef}
                                    className="dropdown-modal"
                                >
                                    {actions.map((action, index) => (
                                        <ListItem
                                            key={index}
                                            onClick={(e) => handleActionItemClick(e, selectedGroupId, action)}
                                        >
                                            <ListItemButton>
                                                <ListItemText
                                                    primary={action}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                    ))}
                                </List>
                            )}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </BaseTable >
    )
}